const LoadingSpinner: React.FC = () => {
  return <span className="spinner" />;
};

export default LoadingSpinner;
